<template>
    <section class="abs sidebar-container" @click.self="closeAllMenus();">
        <div class="abs sidebar-item"><slot></slot></div>
    </section>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "Sidebar",
    methods: {
        ...mapActions("plano/status", {
            closeAllMenus: "closeAllMenus"
        })
    }
};
</script>

<style scoped lang="scss">
.sidebar-container {
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 20;
    background-color: transparent;
}

.sidebar-item {
    top: 0px;
    left: 70px;
    width: 25%;
    z-index: 20;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?1e88ef5c